import React from 'react'
import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'

import { alpha, useTheme } from '@mui/material/styles'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { StaticDatePicker } from '@mui/x-date-pickers'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

import { Drawer, useFinstrongStore, useGlobalCopyStore, useUserStore } from '../../common'

interface ManageDOBProps {
  isOpen: boolean
  onClose: () => void
}

const ManageDOB = ({ isOpen, onClose }: ManageDOBProps) => {
  const { finstrong: finstrongCopy } = useGlobalCopyStore()
  const theme = useTheme()
  const { updateUser, user } = useUserStore()
  const { loadPeerScore } = useFinstrongStore()
  const [selectedDate, setSelectedDate] = React.useState<number | null | undefined>(user.birthday)

  const handleChange = (date: Date | null) => {
    setSelectedDate(Math.floor(new Date(date!).getTime() / 1000))
  }
  const handlePrimaryAction = () => {
    if (!selectedDate || selectedDate === user.birthday) return
    updateUser({ ...user, birthday: selectedDate }).finally(() => {
      loadPeerScore()
    })
    onClose()
  }

  return (
    <Drawer
      footerStyles={{ borderTop: 1, borderColor: 'divider', px: 24, py: 16 }}
      isOpen={isOpen}
      onClose={onClose}
      onPrimaryAction={handlePrimaryAction}
      onSecondaryAction={onClose}
      title={finstrongCopy.date_of_birth}
    >
      <Stack sx={{ bgcolor: 'background.default', height: '100%' }}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          {/* TODO: Use the existing Calendar component, but update a few things in it */}
          <StaticDatePicker
            disableFuture={true}
            onChange={handleChange}
            slotProps={{
              nextIconButton: {
                sx: {
                  color: 'primary.main',
                  '&:hover': { bgcolor: alpha(theme.palette.primary.light, 0.1) },
                },
              },
              previousIconButton: {
                sx: {
                  color: 'primary.main',
                  '&:hover': { bgcolor: alpha(theme.palette.primary.light, 0.1) },
                },
              },
              switchViewButton: {
                sx: {
                  color: 'primary.main',
                  '&:hover': { bgcolor: alpha(theme.palette.primary.light, 0.1) },
                },
              },
            }}
            slots={{
              actionBar: () => null,
              toolbar: () => null,
            }}
            sx={{
              width: '100%',
              '& .MuiIconButton-edgeEnd': {
                color: 'primary.main',
                '&:hover': { bgcolor: alpha(theme.palette.primary.light, 0.1) },
              },
            }}
            value={selectedDate ? new Date(selectedDate * 1000) : new Date()}
          />
        </LocalizationProvider>
      </Stack>
    </Drawer>
  )
}

export default observer(ManageDOB)
